<template>
  <div>
    <v-row>
      <v-col cols="6" md="3" class="py-0">
        <v-menu
          v-model="startDateMenu"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="filters.start_date"
              label="מתאריך"
              prepend-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="filters.start_date"
            @input="(startDateMenu = false), $emit('updateReport')"
            no-title
            scrollable
          ></v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="6" md="3" class="py-0">
        <v-menu
          v-model="endDateMenu"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="filters.end_date"
              label=" עד תאריך "
              prepend-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="filters.end_date"
            @input="(endDateMenu = false), $emit('updateReport')"
            no-title
            scrollable
          ></v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="12" md="3" class="py-0">
        <v-select
          v-model="filters.status"
          :items="statuses"
          item-text="text"
          item-value="value"
          label="סטטוס"
          multiple
          chips
          @change="$emit('updateReport')"
        ></v-select>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "Filters",
  props: ["filters"],
  data() {
    return {
      startDateMenu: false,
      endDateMenu: false,
      statuses: [
        { text: "חדש", value: "new" },
        { text: "בהכנה", value: "preparation" },
        { text: "מוכן", value: "ready" },
        { text: "במשלוח", value: "in_progress_delivery" },
        { text: "המשלוח הגיע", value: "delivery_arrived" },
        { text: "הושלם", value: "done" },
        { text: "בוטל", value: "canceled" },
      ],
    };
  },
  computed: {

  },
  methods: {

  },
};
</script>
